<template>
  <svg width="15px" height="15px" viewBox="0 0 15 15" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <!-- Generator: sketchtool 55.2 (78181) - https://sketchapp.com -->
      <title>3F00B732-1154-411E-9214-252B68E713A1</title>
      <desc>Created with sketchtool.</desc>
      <g id="Linear" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" opacity="0.499883743" class="defaultOpactiy" :class="{'activeOpacity': editModeActive }">
          <g id="1-Linear-Workbench-MRI-Empty-Default" transform="translate(-678.000000, -79.000000)" fill-rule="nonzero" class="default" :class="{'yellow-pencil': editModeActive }">
              <g id="Attribute-Panel">
                  <g id="noun_Pencil_1772505" transform="translate(678.000000, 79.000000)">
                      <path d="M9.3263947,2.50796678 L12.3822923,5.58164035 L4.65818308,13.3318234 L1.62103335,10.2770067 L9.3263947,2.50796678 Z M14.7070242,1.77254795 L13.338432,0.395994754 C12.8134925,-0.131998251 11.951092,-0.131998251 11.4261525,0.395994754 L10.1138039,1.71597727 L13.1697015,4.78965084 L14.6882763,3.2622425 C15.1007288,2.82853396 15.1007288,2.1685427 14.7070242,1.77254795 Z M0.00871929689,14.5763783 C-0.0475242166,14.8215179 0.177449837,15.0478007 0.421171729,14.99123 L3.81453038,14.1615267 L0.796128486,11.10671 L0.00871929689,14.5763783 Z" id="Shape"></path>
                  </g>
              </g>
          </g>
      </g>
  </svg>
</template>

<script>
  export default {
    props: {
      editModeActive: {
        type: Boolean,
        default: false
      }
    }
  }
</script>

<style lang="scss">
  .defaultOpactiy {
    opacity:0.499883743;
  }
  .default {
    fill: #ffffff;
  }
  .activeOpacity {
    opacity: 1;
  }
  .yellow-pencil {
    fill: #ffbD02;
  }
</style>



// WEBPACK FOOTER //
// EditIcon.vue?63abed5a